"use client";

import { useEffect, useState, useSyncExternalStore } from "react";
import { readShellSource } from "./playground-sw-client";

function subscribe(callback: () => void): () => void {
  window.addEventListener("online", callback);
  window.addEventListener("offline", callback);
  return () => {
    window.removeEventListener("online", callback);
    window.removeEventListener("offline", callback);
  };
}

function getSnapshot(): boolean {
  return navigator.onLine;
}

/** The server render assumes online; the client corrects it before paint. */
function getServerSnapshot(): boolean {
  return true;
}

export type ShellSource = "network" | "cache";

export type Connectivity = {
  /** `false` only when the browser knows it has no network (`PG-PWA01`). */
  online: boolean;
  /** Whether this document came from the offline shell worker's cache. */
  shellSource: ShellSource;
};

/**
 * Connectivity as the browser reports it, plus where this shell came from.
 *
 * `online` drives the offline state of Run, save, share, AI and snippet
 * reads. `shellSource` is read once from the meta tag the worker injects
 * (`public/playground-sw.js`) into a cached copy; it is read after mount so
 * the server and client renders agree.
 */
export function useConnectivity(): Connectivity {
  const online = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  const [shellSource, setShellSource] = useState<ShellSource>("network");
  useEffect(() => {
    setShellSource(readShellSource());
  }, []);
  return { online, shellSource };
}
